module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "display-flex justify-space-between align-center mb-4"
  }, [_c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": require("../../assets/mobile/notification_2.png"),
      "width": 30,
      "height": 30
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-16 text-black font-weight-500"
  }, [_vm._v("SALVA")])]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-15 btn-cancel font-weight-400",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'NotificationMobile'
        })
      }
    }
  }, [_vm._v("\n      Cancel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex gap-8 mb-3"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": require("../../assets/mobile/notification_2.png"),
      "width": 30,
      "height": 30
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-15 full-width message__input"
  }, [_c('input', {
    staticClass: "full-width px-3",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "rounded",
    attrs: {
      "src": require("../../assets/mobile/icon/send.svg"),
      "width": 35,
      "height": 35
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message__from pa-3"
  }, [_c('div', {
    staticClass: "text-poppins-14 font-weight-500 text-black"
  }, [_vm._v("Origami")]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-14 text-gray-dark my-1"
  }, [_vm._v("\n        I’m down! Any ideas??\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-poppins-12"
  }, [_vm._v("11:35 AM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-end"
  }, [_c('div', {
    staticClass: "message__to pa-3"
  }, [_c('div', {
    staticClass: "text-poppins-14 font-weight-500 text-white"
  }, [_vm._v("\n        I can do 10 pair of them..\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-poppins-12 text-white"
  }, [_vm._v("1d")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9e51de","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/messages.vue
// module id = 1740
// module chunks = 180